"use strict";

exports.__esModule = true;
var _LogbookTicketDetails = require("./LogbookTicketDetails");
Object.keys(_LogbookTicketDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookTicketDetails[key]) return;
  exports[key] = _LogbookTicketDetails[key];
});